import { render, staticRenderFns } from "./DriverDetails.vue?vue&type=template&id=c42bb05c&"
import script from "./DriverDetails.vue?vue&type=script&lang=js&"
export * from "./DriverDetails.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports